import { Spinner, SpinnerSize, Toggle } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { ADD_IDGINTEGRATION, ADD_NAME } from '../../../actions/types'
import RequiredTextField from '../../formFields/RequiredTextField'
import Api from '../../../services/Api'

const IdgExistingNumber = ({name}) => {

    const dispatch = useDispatch()
    const [isProjectNameValidating, setIsProjectNameValidating] = useState(false)
    const [projectNameValidationResult, setProjectNameValidationResult] = useState()
    const [existingNumberValidationResult, setExistingNumberValidationResult] = useState()
    const idgIntegration = useSelector((state) => state.newSite.idgIntegration)
    const template = useSelector((state) => state.newSite.Template)

    useEffect(() => {
      validateExistingSerieNumber(getExistingSerieNumber())
      if (idgIntegration.existingProjectName)
            validateProjectInIDG(idgIntegration.existingProjectName)
    }, [])
    

    const dispatchIdgIntegration = (payload) => {
        dispatch({ type: ADD_IDGINTEGRATION, payload })
    }

    const getSerieNumberPrefix = () => {
        return idgIntegration.serieNumber.replace('NNNNNN', '');
    }

    const validateExistingSerieNumber = (value) => {
        const valid = {
            isValid: true,
            message: "",
            hideIfNotNeeded: true
        }
        if (!value.match(/^\d{6}$/)) {
            valid.isValid = false
            valid.message = 'Serie Number should contain 6 digits.'
        }
        setExistingNumberValidationResult(valid)

        return valid.isValid
    }
    
    const getExistingSerieNumber = () => {
        return (idgIntegration.existingSerieNumber || '').replace(getSerieNumberPrefix(), '')
    }

    const setExistingSerieNumber = (e, value) => {
        dispatchIdgIntegration({...idgIntegration, existingSerieNumber: getSerieNumberPrefix() + value})

        if (validateExistingSerieNumber(value)) {
            dispatch({ type: ADD_NAME })
        }
    }

    const setExistingProjectName = (e, value) => {
        dispatchIdgIntegration({...idgIntegration, existingProjectName: value})
    }

    const _onToggleChange = (e, checked) => {
        dispatchIdgIntegration({...template.config.idgIntegration, subSerieDelimiter: idgIntegration.subSerieDelimiter, existingSerieNumber: '', existingProjectName: '', useExistingNumber: checked, idgValidationNeeded: true})
    }

    const _onExistingProjectNameBlur = () => {
        if (idgIntegration.existingProjectName)
            validateProjectInIDG(idgIntegration.existingProjectName)
        else
            setProjectNameValidationResult({isValid: true})
    }

    const validateProjectInIDG = async (name) => {
        setProjectNameValidationResult({isValid: false})
        setIsProjectNameValidating(true)

        var validationUrl = `/entryvalidation?title=${encodeURIComponent(name.trim())}&idgInstanceCode=${idgIntegration.instanceCode}&shouldExist=true`

        const result = await Api.get(validationUrl)

        setProjectNameValidationResult(result.data)      
        setIsProjectNameValidating(false)
    }

    const toggle =  <Toggle 
                        label='Do you require to connect to existing IDG Number?' 
                        onText='Yes'
                        offText='No'
                        defaultChecked={idgIntegration.useExistingNumber}
                        onChange={_onToggleChange}
                    />

    const containerStyles = {
        marginBottom: 7,
        position: 'relative'
    }

    const controlStyles = {
        position: 'absolute',
        top: '170px',
        width: '100%'
    }

    const instanceCodeContainer =   <div style={containerStyles}>
                                        <RequiredTextField
                                            label="IDG Instance"
                                            name="IDG Instance"
                                            defaultValue={idgIntegration.instanceCode}
                                            inline
                                            width={250}
                                            disabled
                                            notRequired
                                        />
                                    </div>

    const serieNumberContainer =    <div style={containerStyles}>
                                        <RequiredTextField 
                                            label="Existing IDG Serie Number"
                                            name="Existing IDG Serie Number"
                                            onChange={setExistingSerieNumber}
                                            value={getExistingSerieNumber()}
                                            validationResult={existingNumberValidationResult}
                                            inline
                                            width={250}
                                            prefix={getSerieNumberPrefix()}
                                            title='6 digit number'
                                        />
                                    </div>

    const validatingSpinner = <div title='Validating...' className='validation-spinner-noLabel'><Spinner size={SpinnerSize.medium} /></div>
    const existingProjectName =  <div style={containerStyles}>
                                            {isProjectNameValidating && validatingSpinner}
                                            <RequiredTextField 
                                                label="Existing IDG Project Name"
                                                name="Existing IDG Project Name"
                                                onChange={setExistingProjectName}
                                                value={idgIntegration.existingProjectName}
                                                validationResult={projectNameValidationResult}
                                                onBlur={_onExistingProjectNameBlur}
                                                inline
                                                width={250}
                                                notRequired
                                            />
                                        </div>

    return(
        <div style={controlStyles}>
            {toggle}
            {idgIntegration.useExistingNumber && 
                <div>
                    {instanceCodeContainer}
                    {serieNumberContainer}
                    {existingProjectName}
                </div>
            }
        </div>
    )
}

export default IdgExistingNumber


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/IdgExistingNumber.js